import { Monogram } from "@ellaandil/ui";
import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Typography } from "@/components/ui/Typography";
import type { FooterMarqueeItemStoryblok } from "@/generated/sb/sb-types";

export const FooterMarqueeItemBlok = ({ blok }: BlokProps<FooterMarqueeItemStoryblok>) => {
	return (
		<BlokWrap editable={blok} as="div" className="flex items-center gap-13 shrink-0">
			<Typography
				variant="heading-display-sm"
				className="text-text-sand-text-1 whitespace-nowrap md:text-[26px]"
			>
				{blok.text}
			</Typography>
			<Monogram height={48} width={48} className="text-text-sand-text-1" />
		</BlokWrap>
	);
};
